import { render } from "./ModalComponent.vue?vue&type=template&id=6e135838&scoped=true"
import script from "./ModalComponent.vue?vue&type=script&lang=js"
export * from "./ModalComponent.vue?vue&type=script&lang=js"

import "./ModalComponent.vue?vue&type=style&index=0&id=6e135838&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-6e135838"

export default script